<template>
  <div class="page page-work-hard">

    <div class="hero work-hard-hero no-hero-img">

      <div class="hero-content middle">
        <h1 class="page-title">
          Work Hard
          <small>Fitness</small>
        </h1>
      </div>
      <div class="wave-bottom">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="140px" viewBox="20 -20 300 100" xml:space="preserve">
          <path class="fill-primary" opacity=".075" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729 c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z"></path>
          <path class="fill-primary" opacity=".075" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729 c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z"></path>
          <path class="fill-primary" opacity="0" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716 H42.401L43.415,98.342z"></path>
          <path class="fill-white" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428 c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z"></path>
        </svg>
      </div>
    </div>

    <div class="work-hard-content">

      <div class="container">
        <div class="fc-row">
          <div class="fc-img">
            <img src="https://picsum.photos/g/400/400" alt="" />
          </div>
          <div class="fc-content">
            <div class="fc-content-inner">
                <p>I know you’ve heard all the reasons you should be working out... builds aerobic power, regulates weight, reduces blood pressure, lowers Type 2 diabetes risk, maintains immune functioning, reduces body fat, keeps bones strong, builds muscle mass, improves breathing, better sex, and on and on... (blah, blah, blah, right?).</p>
            </div>
          </div>
        </div>

        <div class="fc-row justify-content-center">
          <div class="fc-content">
            <div class="fc-content-inner">
              <p class="mb-3">How about this,</p>
              <blockquote class="blockquote bb-bq">
                <p>"Strong people are harder to kill and all around more productive in life."</p>
                <footer class="blockquote-footer"><cite title="Source Title">Mark Rippetoe</cite></footer>
              </blockquote>
            </div>
          </div>
        </div>

        <div class="fc-row fc-row-alternate">
          <div class="fc-img">
            <img src="../assets/img/thumb/beach-fitness-female.jpg" alt="" />
          </div>
          <div class="fc-content">
            <div class="fc-content-inner">
                <p>Feeling powerful and productive, it’s just that simple. Hard work will help you look better, feel better and do better.</p>
            </div>
          </div>
        </div>

        <p class="lead text-center mt-5 mb-5">Let's get moving!</p>
      </div>

      <!-- Services -->
      <Services />

    </div>

  </div>
</template>

<script>
import Services from '@/components/Services'

export default {
  components: {
    Services
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.work-hard-hero {
  margin-bottom: 20px;
  background: $bb-blue-lightest;

  .wave-bottom {
    position: absolute;
    right: 0;
    left: 0;
    bottom: -20px;
  }

  @include media-breakpoint-up(md) {
    margin-bottom: 40px;
  }
}
</style>
